import { createSnapshotValue as createMutable } from '../../lib/snapshot-value.ts'
export interface MachineSession {
  id: string
  equipmentId: string
  operatorId: string
  start: string
  end: string
  zmNumber: string
  stageLabel: string
  productName: string
  good: string
  scrap: string
  unit: string
}

export interface RepairPeriod {
  equipmentId: string
  from: string
  /** Null while the machine is still under repair. */
  to: string | null
  reason: string
}

/** Finished repairs. A repair still in progress lives in the store, set from «Обладнання». */
export const REPAIR_LOG: RepairPeriod[] = createMutable([] as RepairPeriod[])

/** The milling machine has been down since 7 October; no history is generated after that. */

export const MACHINE_SESSIONS: MachineSession[] = createMutable([] as MachineSession[])
